





import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import {getStoredProcedure} from '@/data/repos/storedProcedure'
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {defineComponent} from "@vue/composition-api"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {getLocationCaption} from "@/data/sources/appraisal"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "ComplianceOutstandingActions",
    title: "Outstanding actions",
    cType: "text",
    w: 2,
    h: 2,
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  const r = await getStoredProcedure("AnalyticsCenter", "widget_ComplianceOutstandingActions",
    [parseInt(params.locationId && params.locationId.value || "10"), 1 /* user_id */])
  return {value: formatNumberWithGrouping(r[0].Value)}
}

async function titleCallback(config: any) {
  return "Location: " + await getLocationCaption(config.params.locationId)
}

export default defineComponent({
  props: {config: Object},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      const locationId = props.config && props.config.params.locationId.value
      // const locationId = parseInt(props.params.locationId && params.locationId.value || "10")
      bus.$emit('chartPopup', {
        title: 'Outstanding actions',
        component: drillDown,
        componentArgs: { locationId }
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})

const drillDown = () => ({
  component: import('@/components/drilldowns/ComplianceOutstandingActionsDrillDown.vue'),
})
